import styled, { css } from 'styled-components'
import {
  CertInput,
  CertSubmitBtn,
  PhoneVerificationWrap,
  TelInput,
  TelPhoneNumWrap,
  TelSelectorWrap,
  Telecoms,
} from '../RopForm/PhoneVerification'
import sktActive from 'src/assets/images/icon_skt_on.png'
import ktActive from 'src/assets/images/icon_kt_on.png'
import lgActive from 'src/assets/images/icon_lg_on.png'

export const Rop01PhoneVerificationWrap = styled(PhoneVerificationWrap)`
  border: none;
  background: none;
`
export const Rop01TelSelectorWrap = styled(TelSelectorWrap)`
  margin: 8px auto;
`
export const Rop01Telecoms = styled(Telecoms)`
  background-color: #e5e5e5;
  ${(props) =>
    props.bgActive &&
    css`
      border: 3px solid ${props.actColor};
      background-color: #fff;

      &.skt {
        background-size: auto 35px;
        background-image: url(${sktActive});
      }

      &.kt {
        background-image: url(${ktActive});
      }

      &.lg {
        background-image: url(${lgActive});
      }
    `}
`
export const Rop01TelPhoneNumWrap = styled(TelPhoneNumWrap)``
export const Rop01TelInput = styled(TelInput)`
  margin: 0 auto 8px;

  &:focus {
    outline: 1px solid #21f;
  }
`
export const Rop01CertSummitBtn = styled(CertSubmitBtn)``
export const Rop01CertInput = styled(CertInput)`
  &:focus {
    outline: 1px solid #21f;
  }
`
